import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { components } from "react-select";
import SVGFlagIcon from "~components/atoms/svg_flag_icon/svg_flag_icon";
import countryToIsoCode from "~utils/country_utils/country_to_iso_code";
import { wrapperStyle } from "./search_refine_multi_select_checkbox_option_flag.module.scss";

const SearchRefineMultiSelectCheckboxOptionFlag = (props) => {
  const { Option } = components;
  const officeName = props.label;
  const countryCode = useMemo(() => {
    return countryToIsoCode(officeName);
  }, [officeName]);

  if (countryCode && countryCode.length === 2) {
    return (
      <Option {...props}>
        <div className={wrapperStyle}>
          <input
            type="checkbox"
            id={props.label}
            checked={props.data.isRefined}
          />
          <SVGFlagIcon
            small
            countryCode={countryCode}
            altText={`${props.data.label}`}
          />
          {props.label}
        </div>
      </Option>
    );
  }
  return null;
};

SearchRefineMultiSelectCheckboxOptionFlag.propTypes = {
  data: PropTypes.shape({
    isRefined: PropTypes.bool,
    label: PropTypes.string,
  }).isRequired,
  label: PropTypes.string,
};

SearchRefineMultiSelectCheckboxOptionFlag.defaultProps = {
  label: null,
};

export default SearchRefineMultiSelectCheckboxOptionFlag;
